import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { getEnvName } from '../../shared/helpers';

@Component({
  selector: 'app-home',
  imports: [RouterLink],
  templateUrl: './home.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './home.css',
})
export class Home implements OnInit {
  ngOnInit() {
    console.log('env name >> ', getEnvName())
  }
}
